<template lang="pug">
    //- 保养工单 - 首页
    div.work-order-maintenance-home(
        v-if="getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderRead')"
        v-loading="loading"
        element-loading-text="玩命加载中"
    )
        list-title(
            title="保养工单"
            v-if="isStore"
        )
            //- 门店版本购买服务入口
            div(slot="intro")
                purchase-services-button(v-if="purchaseServiceFlag")
            div(
                slot="operate-btns"
            )
                el-switch(
                    disabled
                    v-model="serviceRecordSwitch"
                    active-color="#4877F4"
                    inactive-color="#BABABA"
                    :active-value="true"
                    :inactive-value="false"
                )
                span.tip 保养服务记录显示
                el-tooltip(
                    effect="light"
                    content="用于控制门店工单处理记录是否完整显示在凯励程APP服务详情页，开关ON-服务记录完整显示，开关OFF-服务记录不显示"
                    placement="left"
                )
                    svg-icon(
                        icon-class="help-collision"
                        className="tooltip-sign"
                    )
        div.work-order-maintenance-home-tabs
            count-tabs.count-tabs(
                :value="activeStatus"
                :options="tabOptions"
                @tab-click="tabClick"
            )
                el-button.button(
                    v-if="getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderCreate', true) && isStore"
                    round
                    type="primary"
                    :disabled="!getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderCreate')"
                    @click="handleAdd"
                )
                    i.el-icon-plus
                    span 创建工单
                //- 集团版本购买服务入口
                purchase-services-button.purchase-button(v-if="!isStore&&purchaseServiceFlag")
        div.work-order-maintenance-home-table
            DataList(
                ref="dataList"
                :props="props"
                :key="activeStatus"
                @search="search"
                @reset="reset"
                @beforeExport="exportList"
                @downloadComplete="downloadComplete"
                @downloadComplete2="downloadComplete2"
                @getFormInstance="getFormInstance"
            )
                el-table(
                    :data="tableData"
                    empty-text="暂未查询到结果"
                )
                    el-table-column(
                        prop="orgName"
                        label="店铺名称"
                        align="center"
                        width="200"
                        v-if="userInfo.mode === 3"
                    )
                        template(
                            slot-scope="scope"
                        )
                            span {{ scope.row.orgName | fieldVaild }}
                    el-table-column(
                        prop="id"
                        label="工单编号"
                        align="center"
                        width="150"
                    )
                        template(
                            slot-scope="scope"
                        )
                            span {{ scope.row.id | fieldVaild }}
                    el-table-column(
                        prop="orderStatus"
                        label="工单状态"
                        align="center"
                        width="90"
                    )
                        template(
                            slot-scope="scope"
                        )
                            work-order-status-card.status-card(:status="scope.row.orderStatus")
                    el-table-column(
                        prop="assigneeName"
                        label="服务顾问"
                        align="center"
                        width="100"
                    )
                        template(
                            slot-scope="scope"
                        )
                            div(v-if="!scope.row.assigneeName && !scope.row.assigneePhone") 未分配
                            div(v-if="scope.row.assigneeName") {{ scope.row.assigneeName }}
                            div(v-if="scope.row.assigneePhone") {{ scope.row.assigneePhone }}
                    el-table-column(
                        prop="name"
                        label="联系人"
                        align="center"
                        width="100"
                    )
                        template(
                            slot-scope="scope"
                        )
                            div {{ scope.row.contactName | fieldVaild }}
                            div {{ scope.row.contactPhone | fieldVaild }}
                    el-table-column(
                        prop="plateNumber"
                        label="车牌号码"
                        align="center"
                        width="90"
                    )
                        template(
                            slot-scope="scope"
                        )
                            span {{ scope.row.plateNumber | fieldVaild }}
                    el-table-column(
                        prop="vin"
                        label="车架号"
                        align="center"
                        width="120"
                    )
                        template(
                            slot-scope="scope"
                        )
                            span {{ scope.row.vin | fieldVaild }}
                    el-table-column(
                        prop="vehicleModel"
                        label="车型"
                        align="center"
                    )
                        template(
                            slot-scope="scope"
                        )
                            div.two-line(v-if="scope.row.vehicleModel")
                                el-tooltip(
                                    placement="top"
                                    width="300"
                                    trigger="hover"
                                    popper-class="store-address-popper"
                                )
                                    div(slot="content")
                                        section
                                            span {{ scope.row | vehicleBrandAndSerial | fieldVaild }}
                                    section
                                        span {{ scope.row | vehicleBrandAndSerial | fieldVaild }}
                            span(v-else) {{ scope.row | vehicleBrandAndSerial | fieldVaild }}
                    el-table-column(
                        prop="orderSource"
                        label="来源"
                        align="center"
                        width="100"
                    )
                        template(
                            slot-scope="scope"
                        )
                            span {{ scope.row.orderSource | workOrderSource | fieldVaild }}
                    el-table-column(
                        prop="createTime"
                        label="下单时间"
                        align="center"
                        width="90"
                    )
                        template(
                            slot-scope="scope"
                        )
                            span {{ scope.row.createTime | dateFormat('YYYY/MM/DD HH:mm:ss') | fieldVaild }}
                    el-table-column(
                        prop="bookingTime"
                        label="预约时间"
                        align="center"
                        width="90"
                    )
                        template(
                            slot-scope="scope"
                        )
                            div {{ scope.row.bookingTime | dateFormat('YYYY/MM/DD HH:mm') | fieldVaild }}
                    el-table-column(
                        prop="planDeliverDate"
                        label="预计交车时间"
                        align="center"
                        width="100"
                    )
                        template(
                            slot-scope="scope"
                        )
                            div {{ scope.row.planDeliverDate | dateFormat('YYYY/MM/DD') | fieldVaild }}
                    el-table-column(
                        prop="completeTime"
                        label="交付时间"
                        align="center"
                        width="90"
                    )
                        template(
                            slot-scope="scope"
                        )
                            span {{ scope.row.completeTime | dateFormat('YYYY/MM/DD HH:mm') | fieldVaild }}
                    el-table-column(
                        prop="paymentAmount"
                        label="结算金额(元)"
                        align="center"
                        width="100"
                    )
                        template(
                            slot-scope="scope"
                        )
                            span {{ scope.row.paymentAmount | fieldVaild }}
                    el-table-column(
                        prop="serviceRating"
                        label="客户评价"
                        align="center"
                        width="100"
                    )
                        template(
                            slot-scope="scope"
                        )
                            span {{ scope.row.serviceRating | fieldVaild }}
                    el-table-column(
                        prop="nextMaintenanceTime"
                        label="下次保养时间"
                        align="center"
                        width="100"
                    )
                        template(
                            slot-scope="scope"
                        )
                            div {{ scope.row.nextMaintenanceTime | dateFormat('YYYY/MM/DD') | fieldVaild }}
                    el-table-column(
                        prop="nextMaintenanceProject"
                        label="下次保养项目"
                        align="center"
                        width="110"
                        :show-overflow-tooltip="true"
                    )
                        template(
                            slot-scope="scope"
                        )
                            span {{ scope.row.nextMaintenanceProject | fieldVaild }}
                    el-table-column(
                        prop="clueId"
                        label="线索编号"
                        align="center"
                        width="110"
                        :show-overflow-tooltip="true"
                    )
                        template(
                            slot-scope="scope"
                        )
                            span {{ scope.row.clueId | fieldVaild }}
                    el-table-column(
                        fixed="right"
                        label="操作"
                        align="center"
                        :width="'240px'"
                    )
                        template(slot-scope="scope")
                            el-button(
                                type="text"
                                :disabled="!getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderDetail')"
                                @click="showDetail(scope.row)"
                            ) 详情
                            el-button(
                                type="text"
                                :disabled="!getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderCancel')"
                                @click="handleCancel(scope.row)"
                                v-if="(['CHECKING'].includes(scope.row.orderStatus)) && isStore && getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderCancel', true)"
                            ) 取消工单
                            el-button(
                                type="text"
                                :disabled="!getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderOperate')"
                                @click="handleResolve(scope.row)"
                                v-if="(['IN_DELIVERY', 'CHECKING', 'UNDER_CONSTRUCTION'].includes(scope.row.orderStatus)) && isStore && getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderOperate', true)"
                            ) 去处理
                            el-button(
                                type="text"
                                :disabled="!getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderDistribution')"
                                @click="handleDistribution(scope.row)"
                                v-if="(['IN_DELIVERY', 'CHECKING', 'UNDER_CONSTRUCTION'].includes(scope.row.orderStatus)) && isStore && getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderDistribution', true)"
                            ) 分配顾问
        cancel-order(
            v-if="cancelData.show"
            :dialogData="cancelData"
            @refresh="refreshList"
        )
        resolve-order-maintain(
            v-if="resolveData.show"
            :dialogData="resolveData"
            @refresh="refreshList"
        )
        distribute-order(
            v-if="distributionData.show"
            :dialogData="distributionData"
            @update="refreshList"
        )
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import {
    workOrderStatus, workOrderSource, handleParameter, nameAndPhone,
} from '@/filters';
import clientWidth from '../../../mixins/clientWidth.js';
import CountTabs from '@/components/CountTabs.vue';
import ResultCount from '@/components/ResultCount.vue';
import ExportList from '@/components/ExportList.vue';
import DataList from '@/components/DataList.vue';
import ListTitle from '@/components/ListTitle';
import CancelOrder from '@/components/workOrder/CancelOrder.vue';
import DistributeOrder from '@/components/workOrder/DistributeOrder.vue';
import ResolveOrderMaintain from '@/components/workOrder/ResolveOrderMaintain.vue';
import WorkOrderStatusCard from '@/components/workOrder/WorkOrderStatusCard.vue';
import { workOrderApis, workOrderX3Apis } from '@/api';
import { pageRefresh } from '@/mixins';

import PurchaseServicesButton from '@/components/PurchaseServices/PurchaseServicesButton.vue';

export default {
    name: 'MaintenanceWorkOrderHome',
    components: {
        CountTabs,
        ResultCount,
        ExportList,
        DataList,
        CancelOrder,
        ResolveOrderMaintain,
        WorkOrderStatusCard,
        ListTitle,
        PurchaseServicesButton,
        DistributeOrder,
    },
    filters: {
        nameAndPhone,
        workOrderStatus,
        workOrderSource,
    },
    mixins: [
        pageRefresh(
            // 从以下页面进入需要刷新
            [
                'MaintenanceWorkOrderDetail',
                'MaintenanceWorkOrderCreate',
            ],
            // 用于刷新的回调方法名, 会接收到路由参数from
            'refreshList',
        ),
        clientWidth,
    ],
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            const myVm = vm;
            myVm.allowSearch = true;
            // 统计跳入
            if (from.name === 'WorkOrderOverviewIndex' || from.name === 'WorkOrderX3OverviewIndex') {
                const params = to.params.formData;
                myVm.allowSearch = false;
                // 兼容（缓存、跳转、DataList组件）处理
                if (!params) {
                    myVm.allowSearch = true;
                    if (from.name === 'WorkOrderX3OverviewIndex') { myVm.activeStatus = 'COMPLETED'; }
                    return;
                }
                myVm.$nextTick(() => {
                    myVm.formInstance.resetFields();
                    myVm.formInstance.setFieldsValue({
                        createTime: [myVm.$dayjs(params.startCreateTime).format('YYYY-MM-DD'), myVm.$dayjs(params.endCreateTime).format('YYYY-MM-DD')],
                        orderSource: params.workOrderSource || null,
                        startCreateTime: params.startCreateTime ? myVm.$dayjs(params.startCreateTime).format('YYYY-MM-DD') : null,
                        endCreateTime: params.endCreateTime ? myVm.$dayjs(params.endCreateTime).format('YYYY-MM-DD') : null,
                        orgIds: params.orgIds || null,
                    });
                });
                myVm.activeStatus = 'CANCELLED';
                setTimeout(() => {
                    myVm.allowSearch = true;
                    myVm.queryParams.status = 'CANCELLED';
                    myVm.queryParams.orderSource = params.workOrderSource;
                    myVm.queryParams.startCreateTime = params.startCreateTime;
                    myVm.queryParams.endCreateTime = params.endCreateTime;
                    myVm.queryParams.orgIds = params.orgIds;
                    myVm.getList();
                    myVm.handleParameterFun();
                }, 10);
            }
            // 凯励程X3保养跳入
        });
    },
    data() {
        return {
            purchaseServiceFlag: true,
            serviceRecordSwitch: true,
            loading: false,
            activeStatus: 'all',
            allowSearch: true,
            props: {
                total: 0,
                labelInset: true,
                setInitParams(done) {
                    done({
                        id: null,
                        contact: null,
                        vin: null,
                        plateNumber: null,
                        orderSource: null,
                    });
                },
                exportUrl: '/work-order/list/export',
                exportUrl2: '/work-order/check-order/list/export',
                spanTxt2: '导出检测单',
                options: [
                    {
                        type: 'input',
                        label: '工单编号',
                        field: 'id',
                        attrs: {
                            placeholder: '请输入工单编号',
                            clearable: true,
                            maxlength: 50,
                        },
                    },
                    {
                        type: 'input',
                        label: '联系人',
                        field: 'contact',
                        attrs: {
                            placeholder: '请输入姓名/手机号',
                            clearable: true,
                            maxlength: 50,
                        },
                    },
                    {
                        type: 'input',
                        label: '车架号',
                        field: 'vin',
                        attrs: {
                            placeholder: '请输入',
                            clearable: true,
                            maxlength: 50,
                        },
                    },
                    {
                        type: 'input',
                        label: '车牌号',
                        field: 'plateNumber',
                        attrs: {
                            placeholder: '请输入',
                            clearable: true,
                            maxlength: 50,
                        },
                    },
                    {
                        type: 'select',
                        label: '来源',
                        field: 'orderSource',
                        default: null,
                        options: [
                            {
                                value: null,
                                label: '全部',
                            },
                            {
                                value: 'ADMIN',
                                label: '直接创建',
                            },
                            {
                                value: 'MAINTAIN_CLUE',
                                label: '保养线索',
                            },
                            {
                                value: 'BOOKING_ORDER',
                                label: '预约订单',
                            },
                        ],
                        attrs: {
                            placeholder: '请选择',
                            clearable: true,
                        },
                    },
                    {
                        type: 'date_range',
                        label: '下单时间',
                        field: 'createTime',
                        startFieldName: 'startCreateTime',
                        endFieldName: 'endCreateTime',
                        spanTimes: 1,
                        attrs: {
                            format: 'yyyy-MM-dd',
                            editable: false,
                            clearable: true,
                        },
                        startAttrs: {
                            placeholder: '选择开始时间',
                        },
                        endAttrs: {
                            placeholder: '选择结束时间',
                        },
                    },
                    {
                        type: 'date_range',
                        label: '预约时间',
                        field: 'bookingTime',
                        startFieldName: 'startBookingTime',
                        endFieldName: 'endBookingTime',
                        spanTimes: 1,
                        attrs: {
                            format: 'yyyy-MM-dd',
                            editable: false,
                            clearable: true,
                        },
                        startAttrs: {
                            placeholder: '选择开始时间',
                        },
                        endAttrs: {
                            placeholder: '选择结束时间',
                        },
                    },
                    {
                        type: 'date_range',
                        label: '预计交车时间',
                        field: 'planDeliverDate',
                        startFieldName: 'startPlanDeliverDate',
                        endFieldName: 'endPlanDeliverDate',
                        spanTimes: 1,
                        attrs: {
                            format: 'yyyy-MM-dd',
                            editable: false,
                            clearable: true,
                        },
                        startAttrs: {
                            placeholder: '选择开始时间',
                        },
                        endAttrs: {
                            placeholder: '选择结束时间',
                        },
                    },
                    {
                        type: 'date_range',
                        label: '下次保养时间',
                        field: 'nextMaintenanceTime',
                        startFieldName: 'startNextMaintenanceTime',
                        endFieldName: 'endNextMaintenanceTime',
                        spanTimes: 1,
                        attrs: {
                            format: 'yyyy-MM-dd',
                            editable: false,
                            clearable: true,
                        },
                        startAttrs: {
                            placeholder: '选择开始时间',
                        },
                        endAttrs: {
                            placeholder: '选择结束时间',
                        },
                    },
                    {
                        type: 'date_range',
                        label: '交付时间',
                        field: 'completeTime',
                        startFieldName: 'startCompleteTime',
                        endFieldName: 'endCompleteTime',
                        spanTimes: 1,
                        attrs: {
                            format: 'yyyy-MM-dd',
                            editable: false,
                            clearable: true,
                        },
                        startAttrs: {
                            placeholder: '选择开始时间',
                        },
                        endAttrs: {
                            placeholder: '选择结束时间',
                        },
                    },
                    {
                        type: 'input',
                        label: '服务顾问',
                        field: 'assigneeContact',
                        attrs: {
                            placeholder: '请输入姓名/手机号',
                            clearable: true,
                            maxlength: 50,
                        },
                    },
                    {
                        type: 'select',
                        label: '是否关联保养线索',
                        field: 'relationClue',
                        default: null,
                        options: [
                            {
                                value: true,
                                label: '是',
                            },
                            {
                                value: false,
                                label: '否',
                            },
                        ],
                        attrs: {
                            placeholder: '请选择',
                            clearable: true,
                        },
                    },
                ],
            },
            tableData: [],
            queryParams: {
                pageSize: 10,
                pageNum: 1,
            },
            tabOptions: [
                { name: 'all', label: '全部', count: 0 },
                { name: 'CHECKING', label: '检测中', count: 0 },
                { name: 'UNDER_CONSTRUCTION', label: '施工中', count: 0 },
                { name: 'IN_DELIVERY', label: '车辆交付', count: 0 },
                { name: 'COMPLETED', label: '已完成', count: 0 },
                { name: 'CANCELLED', label: '已取消', count: 0 },
            ],
            cancelData: {
                show: false,
                id: '',
            },
            resolveData: {
                show: false,
                orderInfo: {},
            },
            distributionData: {
                show: false,
                data: {},
            },
        };
    },
    computed: {
        ...mapGetters('user', [
            'getAuthority',
        ]),
        ...mapState('user', [
            'userInfo',
            'orgList',
        ]),
        isStore() {
            return this.userInfo.orgType === 'STORE';
        },
    },
    created() {
        if (this.userInfo.mode === 3) {
            const options = this.orgList;
            const multipleProps = {
                type: 'select',
                label: '店铺名称',
                field: 'orgIds',
                options,
                attrs: {
                    filterable: true,
                    multiple: true,
                    'collapse-tags': true,
                },
            };
            this.props.options.push(multipleProps);
        }
        this.props.exportDisabled = !this.getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderExport');
        this.handleParameterFun();
        this.getPurchaseServiceFlag();
    },
    methods: {
        getFormInstance(form) {
            this.formInstance = form;
        },
        reset() {
            this.$nextTick(() => {
                this.formInstance.resetFields();
                this.$forceUpdate();
            });
        },
        search(params) {
            let queryParams = params;
            if (queryParams.startBookingTime) {
                queryParams.startBookingTime = this.$dayjs(queryParams.startBookingTime).toISOString();
            }
            if (queryParams.endBookingTime) {
                queryParams.endBookingTime = this.$dayjs(queryParams.endBookingTime).toISOString();
            }
            if (queryParams.startCreateTime) {
                queryParams.startCreateTime = this.$dayjs(queryParams.startCreateTime).toISOString();
            }
            if (queryParams.endCreateTime) {
                queryParams.endCreateTime = this.$dayjs(queryParams.endCreateTime).toISOString();
            }
            if (queryParams.startNextMaintenanceTime) {
                queryParams.startNextMaintenanceTime = this.$dayjs(queryParams.startNextMaintenanceTime).toISOString();
            }
            if (queryParams.endNextMaintenanceTime) {
                queryParams.endNextMaintenanceTime = this.$dayjs(queryParams.endNextMaintenanceTime).toISOString();
            }
            if (queryParams.startCompleteTime) {
                queryParams.startCompleteTime = this.$dayjs(queryParams.startCompleteTime).toISOString();
            }
            if (queryParams.endCompleteTime) {
                queryParams.endCompleteTime = this.$dayjs(queryParams.endCompleteTime).toISOString();
            }

            if (this.activeStatus !== 'all') {
                queryParams = {
                    status: this.activeStatus,
                    ...queryParams,
                };
            } else {
                queryParams.status = null;
            }
            this.queryParams = queryParams;
            this.queryParams.orderType = 'MAINTAIN';
            this.getList();
        },
        refreshList() {
            this.getList();
        },
        async getList() {
            if (!this.getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderRead')) return;
            if (Object.prototype.toString.call(this.queryParams) === '[object Object]') {
                Object.keys(this.queryParams).forEach((key) => {
                    if (this.queryParams[key] === undefined || this.queryParams[key] === '') delete this.queryParams[key];
                    else this.queryParams[key] = this.queryParams[key];
                });
            }
            // 避免重复请求
            if (!this.allowSearch) return;
            try {
                this.loading = true;
                this.props.exportParams = this.queryParams;
                this.props.exportParams2 = this.queryParams;
                const { data } = await workOrderApis.getWorkOrderList(this.queryParams);
                this.tableData = data.pageList ? (data.pageList.list || []) : [];
                this.props.total = data.pageList ? (data.pageList.total || 0) : 0;
                this.serviceRecordSwitch = Boolean(data.visibleServiceRecord);
                if (data.statusCount) this.handleTabsChange(data.statusCount);
            } catch (err) {
                throw new Error(err);
            } finally {
                this.loading = false;
                this.$forceUpdate();
            }
        },
        handleCancel(row) {
            this.cancelData = {
                show: true,
                id: row.id,
            };
        },
        handleResolve(row) {
            this.resolveData = {
                show: true,
                id: row.id,
            };
        },
        handleDistribution(row) {
            this.distributionData = {
                show: true,
                data: row,
            };
        },
        handleTabsChange(stateCount) {
            this.tabOptions = [
                {
                    name: 'all',
                    label: '全部',
                    count: stateCount.allCount || 0,
                },
                {
                    name: 'CHECKING',
                    label: '检测中',
                    count: stateCount.checkCount || 0,
                },
                {
                    name: 'UNDER_CONSTRUCTION',
                    label: '施工中',
                    count: stateCount.constructionCount || 0,
                },
                {
                    name: 'IN_DELIVERY',
                    label: '车辆交付',
                    count: stateCount.deliveryCount || 0,
                },
                {
                    name: 'COMPLETED',
                    label: '已完成',
                    count: stateCount.completeCount || 0,
                },
                {
                    name: 'CANCELLED',
                    label: '已取消',
                    count: stateCount.cancelCount || 0,
                },
            ];
        },
        handleAdd() {
            const {
                navType,
            } = this.$route.query;
            this.$router.push({
                name: 'MaintenanceWorkOrderCreate',
                query: {
                    navType,
                },
            });
        },
        tabClick(tab) {
            if (this.activeStatus === tab.name) return;
            this.activeStatus = tab.name;
            this.handleParameterFun();
        },
        showDetail(row) {
            const {
                navType,
            } = this.$route.query;
            this.$router.push({
                name: 'MaintenanceWorkOrderDetail',
                query: {
                    navType,
                    id: row.id,
                },
            });
        },
        exportList() {
            this.loading = true;
        },
        downloadComplete() {
            this.loading = false;
        },
        downloadComplete2() {
            this.loading = false;
        },
        handleParameterFun() {
            const tabStr = this.tabOptions.find(item => item.name === this.activeStatus).label;
            handleParameter({
                trackKey: 'workorderservice_maintenancelist_maintenancelist_popup',
                attr: {
                    shop_id: this.userInfo.lastLoginOrgId,
                    account_type: this.userInfo.orgType,
                    xyt_id: this.userInfo.id,
                    tab_name: tabStr,
                },
            });
        },
        async getPurchaseServiceFlag() {
            const { data } = await workOrderX3Apis.getExternalServiceFlag();
            this.purchaseServiceFlag = !data;
        },
    },
};
</script>
<style lang="scss" scoped>
    .tip {
        margin-left: 10px;
    }
    .work-order-maintenance-home {
        @include bg_color(color_base_white);
        &-tabs {
            .button {
                padding: 8px 15px !important;
            }
            .purchase-button {
                padding: 14px 0 !important;
            }
        }
        &-table {
            @include bg_color(color_base_white);
            .alliance {
                width: 28px;
                height: 17px;
                line-height: 17px;
                border-radius: 2px;
                position: absolute;
                top: 3px;
                @include bg_color(color_base_red1);
                @include font_size(text_very_small);
                @include font_color(color_base_red4);
            }
            .svg-export {
                width:24px !important;
                height:24px !important;
            }
            .icon {
                width: 60px;
                height: 25px;
            }
        }
        .status-card {
            margin: 0 auto;
        }
        .el-pagination {
            padding: 25px 0;
            text-align: center;
        }
        .two-line {
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            max-height: 46px !important;
        }
        // @include bg_color(color_base_white);
    }
</style>
<style lang="scss">
    .work-order-maintenance-home {
        .el-table td, .el-table th {
            padding: 0;
            height: 50px!important;
            word-break: break-word;
        }
    }
</style>
